import Vue from "vue";
import Vuex from "vuex";
import { Auth, DataStore } from "aws-amplify";
// import router from "@/router";
import { API } from "aws-amplify";
import { appConfigsByKey } from "@/graphql/queries";
import { parseGraphqlResult } from "@/core/utils/parseGraphqlResult";
import * as mutations from "@/graphql/mutations";
import { getAdMeta, saveAdMeta, clearAdMeta } from "@/core/utils/adMeta";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isOnline: true,
    justLoggedIn: false,
    appLoading: false,
    userSignedIn: false,
    fetchedUserGroups: false,
    userGroups: null,
    userEmail: "",
    syncedTeacherProfile: false,
    syncedTeacherProfileModel: null,
    teacherProfileID: "",
    teacherProfileProvince: "",
    teacherProfileSchoolID: "",
    teacherProfilePayfastSubscriptionToken: "",
    teacherProfilePayfastSubscriptionResponse: null,
    teacherProfileAppSyncVersion: "",
    notReadAnnouncements: null,

    appConfigs: [],
    maintenanceLoaded: false,

    subscriptionAccessSynced: false,
    subscriptionAccessRecords: [],
    subscriptionPackages: [],
    subscriptionAccessProductIds: [],

    syncedTeacherProductsOrders: false,
    syncedTeacherProductsOrderModels: [],

    syncedPendingTeacherProductsOrder: null,
    syncedBoughtProducts: [],
    syncedBoughtProductAddons: [],
    syncedPendingProducts: [],

    guestCart: null,
    draftExistingPendingTeacherProductsOrder: false,
    creatingLocalStorageCartOrder: false,

    datastorePredicates: [],
    datastoreSubscriptions: [],
    changingDatastoreConfig: false,
    datastoreReady: false,
    startedDatastoreSync: false,

    productBundleParams: null,
    // teacherProfilePayfastSubscriptionPackage: null,
    // teacherProfileProductSubcriptions: 50,

    subjects: [],
    subjectsLoaded: false,
    loadingSubjects: false,
  },
  getters: {
    sortedSubjects(state) {
      return [...state.subjects].sort(
        (subjectA, subjectB) =>
          String(subjectA.grade).localeCompare(
            String(subjectB.grade),
            undefined,
            { numeric: true },
          ) || String(subjectA.subject).localeCompare(String(subjectB.subject)),
      );
    },

        hasSubscriptionProduct: (state) => (id) =>
      (state.subscriptionAccessProductIds || []).includes(id),

    subscriptionExists: (state) => (model) => {
      return state.datastoreSubscriptions.some((item) => item.model === model);
    },
    maintenanceMode(state) {
      return !!state.appConfigs.maintenance?.enabled;
    },

    pendingProducts(state) {
      return [
        ...state.syncedPendingProducts,
        ...(state.guestCart?.orderProducts?.map((product) => product.id) || []),
      ];
    },

        activeSubscriptionPackages(state) {
      const now = Date.now();
      return (state.subscriptionPackages || []).filter((p) => {
        if (!p || p._deleted || p.active === false) return false;
        if (p.startsAt && new Date(p.startsAt).getTime() > now) return false;
        if (p.expiresAt && new Date(p.expiresAt).getTime() < now) return false;
        return (state.subscriptionAccessRecords || []).some(
          (a) => a.subscriptionPackageID === p.id && a.active !== false,
        );
      });
    },

    hasSubscriptionAccess(state, getters) {
      return getters.activeSubscriptionPackages.length > 0;
    },

    // The subjects the logged-in user can actually see, across all packages.
    subscriptionAccessSubjectIDs(state, getters) {
      const ids = new Set();
      getters.activeSubscriptionPackages.forEach((pkg) => {
        const access = (state.subscriptionAccessRecords || []).find(
          (a) => a.subscriptionPackageID === pkg.id && a.active !== false,
        );
        const list = access?.subjectIDs?.length
          ? access.subjectIDs
          : 
          // pkg.subjectIDs ||    // Access to main Package subjectID's
           [];
        list.forEach((id) => ids.add(id));
      });
      return [...ids];
    },

    hasSubscriptionSubject: (state, getters) => (subjectID) =>
      getters.subscriptionAccessSubjectIDs.includes(subjectID),
  },
  mutations: {
    storeSubjects(state, payload) {
      state.subjects = payload || [];
      state.subjectsLoaded = true;
    },

    storeLoadingSubjects(state, payload) {
      state.loadingSubjects = payload;
    },

        storeSubscriptionAccessProductIds(state, payload) {
      state.subscriptionAccessProductIds = payload || [];
    },

    setAppConfig(state, { key, config }) {
      if (config === null) {
        if (state.appConfigs[key]) {
          Vue.delete(state.appConfigs, key);
        }
      } else {
        Vue.set(state.appConfigs, key, config);
      }
    },

    setMaintenanceLoaded(state, value) {
      state.maintenanceLoaded = value;
    },

    storeJustLoggedIn(state, payload) {
      // console.log('storeTeacherProfileID', payload)
      state.justLoggedIn = payload;

      if (payload) {
        const loginInterval = setInterval(() => {
          if (state.teacherProfileID) {
            console.log("state.teacherProfileID", state.teacherProfileID);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "login",
              user_id: state.teacherProfileID, // Replace with actual teacherprofileID
            });

            clearInterval(loginInterval);
          }
        }, 500);
      }
    },

    changeProductBundleParams(state, payload) {
      state.productBundleParams = payload;
    },

    addSubscriptions(state, subscriptions) {
      state.startedDatastoreSync = true;

      state.datastoreSubscriptions.push(...subscriptions);

      // console.log(
      //   "addSubscriptions",
      //   JSON.stringify(state.datastoreSubscriptions.map((item) => item.model))
      // );
    },

    addSubscription(state, subscription) {
      state.startedDatastoreSync = true;

      state.datastoreSubscriptions.push(subscription);

      // console.log(
      //   "addSubscription",
      //   JSON.stringify(state.datastoreSubscriptions.map((item) => item.model))
      // );
    },

    removeSubscriptions(state, subscriptionsToRemove) {
      try {
        for (const subModel of subscriptionsToRemove) {
          const subscriptionIndex = state.datastoreSubscriptions.findIndex(
            (item) => item.model === subModel,
          );
          if (subscriptionIndex !== -1) {
            state.datastoreSubscriptions[subscriptionIndex].sub.unsubscribe();
            state.datastoreSubscriptions.splice(subscriptionIndex, 1);
          }
        }

        // console.log(
        //   "removeSubscriptions",
        //   JSON.stringify(state.datastoreSubscriptions)
        // );

        // clearSubscribedTeacherData(state);
      } catch (error) {
        console.log("removeSubscriptions error: ", error);
      }
    },

    clearSubscriptions(state) {
      try {
        for (const subscription of state.datastoreSubscriptions) {
          subscription.sub.unsubscribe();
        }

        state.datastoreSubscriptions = [];
        // console.log(
        //   "clearSubscriptions",
        //   JSON.stringify(state.datastoreSubscriptions)
        // );

        // clearSubscribedTeacherData(state);
      } catch (error) {
        console.log("clearSubscriptions error: ", error);
      }
    },

    storeDatastoreReady(state, payload) {
      // console.log("storeDatastoreReady vuex", payload);
      state.datastoreReady = payload;
    },

    changingDatastoreConfig(state, payload) {
      // console.log("changingDatastoreConfig vuex", payload);
      state.changingDatastoreConfig = payload;
    },

    removeDatastorePredicates(state, predicatesToRemove) {
      try {
        for (const predicateModel of predicatesToRemove) {
          // Check if active subscriptions exist for the model
          if (
            state.datastoreSubscriptions.some((item) =>
              item.model.includes(predicateModel),
            )
          ) {
            continue;
          }

          const predicateIndex = state.datastorePredicates.findIndex(
            (item) => item.model === predicateModel,
          );
          if (predicateIndex !== -1) {
            state.datastorePredicates.splice(predicateIndex, 1);
          }
        }

        // console.log(
        //   "removeDatastorePredicates",
        //   JSON.stringify(state.datastorePredicates)
        // );
      } catch (error) {
        console.log("removeDatastorePredicates error: ", error);
      }
    },

    changeDatastorePredicates(state, predicatesToAdd) {
      try {
        for (const predicate of predicatesToAdd) {
          const predicateIndex = state.datastorePredicates.findIndex(
            (item) => item.model === predicate.model,
          );
          if (predicateIndex !== -1) {
            if (!predicate.predicateVariables) {
              const incomingPredicateRole = predicate.predicate; // Assuming this is the incoming role
              const localPredicateRole =
                state.datastorePredicates[predicateIndex].predicate;

              if (
                (localPredicateRole === "Teacher" &&
                  incomingPredicateRole === "Admin") ||
                (localPredicateRole === "Teacher" &&
                  incomingPredicateRole === "SuperAdmin") ||
                (localPredicateRole === "Admin" &&
                  incomingPredicateRole === "SuperAdmin")
              ) {
                state.datastorePredicates[predicateIndex].predicate =
                  incomingPredicateRole;
              }

              state.datastorePredicates[predicateIndex].predicate =
                predicate.predicate;

              if (
                state.datastorePredicates[predicateIndex].predicateVariables
              ) {
                delete state.datastorePredicates[predicateIndex]
                  .predicateVariables;
              }
            } else {
              state.datastorePredicates[predicateIndex].predicate =
                predicate.predicate;

              state.datastorePredicates[predicateIndex].predicateVariables =
                predicate.predicateVariables;
            }
          } else {
            let newPredicate = {
              model: predicate.model,
              predicate: predicate.predicate,
            };

            if (predicate.predicateVariables) {
              newPredicate.predicateVariables = predicate.predicateVariables;
            }

            state.datastorePredicates.push(newPredicate);
          }
        }

        // console.log(
        //   "changeDatastorePredicates",
        //   JSON.stringify(state.datastorePredicates)
        // );
      } catch (error) {
        console.log("changeDatastorePredicates error: ", error);
      }
    },

    changeDatastorePredicate(state, payload) {
      const { model, predicate, predicateVariables } = payload;
      // Find model in state.datastorePredicates to update predicate:
      const modelIndex = state.datastorePredicates.findIndex(
        (item) => item.model === model,
        //  && item.predicate === predicate
      );
      if (modelIndex !== -1) {
        if (!predicateVariables) {
          // state.datastorePredicates.splice(modelIndex, 1);

          state.datastorePredicates[modelIndex].predicate = predicate;
          if (state.datastorePredicates[modelIndex].predicateVariables)
            delete state.datastorePredicates[modelIndex].predicateVariables;
        } else {
          state.datastorePredicates[modelIndex].predicate = predicate;
          state.datastorePredicates[modelIndex].predicateVariables =
            predicateVariables;
        }
      }
      //  if (predicateVariables)
      else {
        let newPredicate = {
          model,
          predicate,
        };

        if (predicateVariables) {
          newPredicate.predicateVariables = predicateVariables;
        }

        state.datastorePredicates.push(newPredicate);
      }

      // console.log(
      //   "changeDatastorePredicate JSON.stringify(state.datastorePredicates)",
      //   JSON.stringify(state.datastorePredicates)
      // );
    },

    storeSyncedTeacherProductsOrders(state, payload) {
      // console.log('storeTeacherProfileModel', payload)
      state.syncedTeacherProductsOrders = payload;
    },

    storeTeacherProductsOrderModels(state, payload) {
      state.syncedTeacherProductsOrderModels = payload;

      const boughtProductOrders =
        payload?.length > 0
          ? payload.filter((order) => order?.orderStatus === "PAID") // Keep only "PAID" orders
          : [];

      const boughtProductIDs =
        boughtProductOrders.length > 0
          ? boughtProductOrders
              .flatMap((order) => order?.orderProducts || []) // Flatten orderProducts
              .flatMap((product) => {
                // Collect product's own ID
                const ids = [product?.id];

                // If product has a .products array with items, collect their IDs too
                if (
                  Array.isArray(product?.products) &&
                  product.products.length > 0
                ) {
                  ids.push(...product.products.map((p) => p?.id));
                }

                return ids;
              })
          : [];

      state.syncedBoughtProducts = boughtProductIDs;

      state.syncedBoughtProductAddons = boughtProductOrders
        .flatMap((order) => order?.orderProducts ?? []) // safe access + fallback to []
        .filter(
          (product) =>
            product != null && // not null or undefined
            Array.isArray(product.addons), // has valid addons array
        )
        .map((product) => ({
          // use map instead of flatMap for objects
          productId: product.id,
          addons: product.addons,
        }));
    },

    storePendingTeacherProductsOrder(state, payload) {
      const pendingTeacherProductsOrder = (() => {
        if (!Array.isArray(payload)) {
          return payload;
        }

        if (!payload?.length) return null;

        // Find the first order with status "QUOTING"
        const quotingOrder = payload.find(
          (order) => order?.orderStatus === "QUOTING",
        );
        if (quotingOrder) {
          return quotingOrder;
        }

        // If no "QUOTING" order, find the first order with status "PENDING"
        const pendingOrder = payload.find(
          (order) => order?.orderStatus === "PENDING",
        );
        if (pendingOrder) {
          return pendingOrder;
        }

        return null;
      })();

      // console.log("pendingTeacherProductsOrder", pendingTeacherProductsOrder);

      const pendingProducts = (() => {
        // console.log("pendingTeacherProductsOrder", pendingTeacherProductsOrder);
        // console.log(
        //   "pendingTeacherProductsOrder.orderProducts",
        //   pendingTeacherProductsOrder?.orderProducts,
        // );
        if (
          !pendingTeacherProductsOrder ||
          !pendingTeacherProductsOrder.orderProducts
        )
          return [];

        return (
          pendingTeacherProductsOrder.orderProducts?.map(
            (product) => product?.id,
          ) || []
        );
      })();

      state.syncedPendingTeacherProductsOrder = pendingTeacherProductsOrder;

      state.syncedPendingProducts = pendingProducts;
    },

    loadGuestCart(state) {
      const saved = localStorage.getItem("guestCart");
      state.guestCart = saved
        ? JSON.parse(saved)
        : { orderProducts: [], coupon: null, orderShippingDetails: null, meta: null };
    },

    // storeGuestCart(state, guestCart) {
    //   state.guestCart = guestCart;
    //   localStorage.setItem("guestCart", JSON.stringify(state.guestCart));
    // },

    storeMetaToGuestCart(state, meta) {
      if (!state.guestCart) {
        state.guestCart = {
          orderProducts: [],
          coupon: null,
          orderShippingDetails: null,
        };
      }
      state.guestCart.meta = meta;
      localStorage.setItem("guestCart", JSON.stringify(state.guestCart));
    },

    storeProductsToGuestCart(state, products) {
      state.guestCart.orderProducts = products;
      localStorage.setItem("guestCart", JSON.stringify(state.guestCart));
    },

    storeShippingToGuestCart(state, shippingDetails) {
      state.guestCart.orderShippingDetails = shippingDetails;
      localStorage.setItem("guestCart", JSON.stringify(state.guestCart));
    },

    storeCouponToGuestCart(state, coupon) {
      state.guestCart.coupon = coupon;
      localStorage.setItem("guestCart", JSON.stringify(state.guestCart));
    },

    // removeProductFromGuestCart(state, productId) {
    //   state.guestCart.orderProducts =
    //     state.guestCart?.orderProducts?.filter((p) => p.id !== productId) || [];
    //   localStorage.setItem("guestCart", JSON.stringify(state.guestCart));
    // },

    clearGuestCart(state) {
      state.guestCart = { orderProducts: [], coupon: null, orderShippingDetails: null, meta: null };
      localStorage.removeItem("guestCart");
    },

    storeNotReadAnnouncements(state, payload) {
      state.notReadAnnouncements = payload;
    },

    storeIsOnline(state, payload) {
      if (state.isOnline !== payload) state.isOnline = payload;
    },

    storeUserGroups(state, payload) {
      state.userGroups = payload;
      state.fetchedUserGroups = true;
      // console.log("storeUserGroups", payload);
    },

    storeAppLoading(state, payload) {
      state.appLoading = payload;
    },

    storeUserSignedIn(state, payload) {
      state.userSignedIn = payload;
    },

    storeUserEmail(state, payload) {
      // console.log('storeUserEmail', payload)
      state.userEmail = payload;
    },

    storeSyncedTeacherProfile(state, payload) {
      // console.log('storeSyncedTeacherProfile', payload)
      state.syncedTeacherProfile = payload;
    },

    storeTeacherProfileModel(state, payload) {
      state.syncedTeacherProfileModel = payload;
      // console.log("storeTeacherProfileModel", payload);
    },

    storeTeacherProfileID(state, payload) {
      // console.log('storeTeacherProfileID', payload)
      state.teacherProfileID = payload;
    },

    storeTeacherProfilePayfastSubscriptionToken(state, payload) {
      // console.log('storeTeacherProfilePayfastSubscriptionToken', payload)
      state.teacherProfilePayfastSubscriptionToken = payload;
    },

    storeTeacherProfilePayfastSubscriptionResponse(state, payload) {
      // console.log('storeTeacherProfilePayfastSubscriptionResponse', payload)
      state.teacherProfilePayfastSubscriptionResponse = payload;
    },

    storeTeacherProfileAppSyncVersion(state, payload) {
      // console.log('storeTeacherProfileAppSyncVersion', payload)
      state.teacherProfileAppSyncVersion = payload;
    },

    storeTeacherProfileProvince(state, payload) {
      // console.log('storeTeacherProfileProvince', payload)
      state.teacherProfileProvince = payload;
    },

    storeTeacherProfileSchoolID(state, payload) {
      // console.log('storeTeacherProfileSchoolID', payload)
      state.teacherProfileSchoolID = payload;
    },
    // storeTeacherProfilePayfastSubscriptionPackage(state, payload) {
    //   // console.log('storeTeacherProfilePayfastSubscriptionPackage', payload)
    //   state.teacherProfilePayfastSubscriptionPackage = payload
    // },
    // storeTeacherProfileProductSubcriptions(state, payload) {
    //   // console.log('storeTeacherProfileProductSubcriptions', payload)
    //   state.teacherProfileProductSubcriptions = payload
    // }

    storeSubscriptionAccessSynced(state, payload) {
      state.subscriptionAccessSynced = payload;
    },

    storeSubscriptionAccessRecords(state, payload) {
      state.subscriptionAccessRecords = payload || [];
    },

    storeSubscriptionPackages(state, payload) {
      state.subscriptionPackages = payload || [];
    },
  },
  actions: {
    // Subjects barely ever change, so fetch them once per session and let
    // every page read them from here. Pass true to force a refetch.
    async fetchSubjects({ state, commit }, force = false) {
      if (state.loadingSubjects) return;
      if (state.subjectsLoaded && !force) return;

      commit("storeLoadingSubjects", true);
      try {
        let allSubjects = [];
        let nextToken = null;

        do {
          const result = await API.graphql({
            query: /* GraphQL */ `
              query ListSubjectsForAdmin($nextToken: String) {
                listSubjects(limit: 1000, nextToken: $nextToken) {
                  items {
                    id
                    grade
                    subject
                    _deleted
                  }
                  nextToken
                }
              }
            `,
            variables: { nextToken },
            authMode: "AMAZON_COGNITO_USER_POOLS",
          });

          allSubjects = allSubjects.concat(result.data.listSubjects.items);
          nextToken = result.data.listSubjects.nextToken;
        } while (nextToken);

        commit(
          "storeSubjects",
          allSubjects.filter((subject) => subject && !subject._deleted),
        );
      } catch (error) {
        console.log("fetchSubjects error:", error);
      } finally {
        commit("storeLoadingSubjects", false);
      }
    },

    async syncAdMetaToCart({ state, commit }) {
      const meta = getAdMeta();
      if (!meta) return; // nothing captured, or already consumed -> can't re-apply

      // Signed-in: wait until orders are synced so we know if a pending order
      // exists. Return WITHOUT consuming; the watcher calls us again when ready.
      if (state.userSignedIn && !state.syncedTeacherProductsOrders) return;

      // Consume synchronously, before any await. Once used it is DELETED, so it
      // can never be applied to a second cart/order. This is the fix - it now
      // applies to guests too (that was the infinite-guest bug).
      clearAdMeta();

      try {
        // GUEST: save onto the guest cart ONCE. It rides to the order at
        // conversion (below), then clearGuestCart wipes it. adMeta is already gone.
        if (!state.userSignedIn) {
          commit("storeMetaToGuestCart", meta);
          return;
        }

        // SIGNED-IN: update the existing pending order, or create one to hold it.
        const pending = state.syncedPendingTeacherProductsOrder;
        if (pending) {
          await API.graphql({
            query: mutations.updateTeacherProductsOrder,
            variables: {
              input: {
                id: pending.id,
                _version: pending._version,
                meta: JSON.stringify(meta),
              },
            },
            authMode: "AMAZON_COGNITO_USER_POOLS",
          });
        } else if (state.teacherProfileID) {
          const now = new Date();
          const month = now.toISOString().slice(0, 7);
          const orderID =
            `${now.getFullYear().toString().slice(-2)}` +
            `${(now.getMonth() + 1).toString().padStart(2, "0")}` +
            `${now.getDate().toString().padStart(2, "0")}-` +
            `${now.getHours().toString().padStart(2, "0")}` +
            `${now.getMinutes().toString().padStart(2, "0")}` +
            `${now.getSeconds().toString().padStart(2, "0")}`;
          await API.graphql({
            query: mutations.createTeacherProductsOrder,
            variables: {
              input: {
                teacherprofileID: state.teacherProfileID,
                orderStatus: "PENDING",
                orderProducts: JSON.stringify([]),
                orderID,
                orderDateTime: now.toISOString(),
                meta: JSON.stringify(meta),
                createdAtMonth: month,
                updatedAtMonth: month,
              },
            },
            authMode: "AMAZON_COGNITO_USER_POOLS",
          });
        } else {
          saveAdMeta(meta); // couldn't attach yet -> restore for a later retry
        }
      } catch (e) {
        console.log("syncAdMetaToCart error:", e);
        saveAdMeta(meta); // failed write -> restore so it retries, doesn't vanish
      }
    },
    
    async fetchAppConfig({ commit, state }, key) {
      try {
        let user = false;
        if (!state.userSignedIn) {
        const currentAuthUser = await Auth.currentAuthenticatedUser().catch(() => {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
      });

      commit("storeUserSignedIn", currentAuthUser ? true : false);
      user = currentAuthUser ? true : false;
    } else {
      user = true
    }

        const result = await API.graphql({
          query: appConfigsByKey,
          variables: { key },
          authMode: user ? "AMAZON_COGNITO_USER_POOLS" : "AWS_IAM",
        });
        const allItems = result?.data?.appConfigsByKey?.items || [];
        const items = parseGraphqlResult(allItems);

        if (items.length > 0) {
          commit("setAppConfig", {
            key,
            config: {
              ...items[0],
              // enabled: false
            },
          });
        }

        if (key === "maintenance") {
          commit("setMaintenanceLoaded", true);
        }
      } catch (error) {
        console.log("fetchAppConfig error:", error);
        if (key === "maintenance") {
          commit("setMaintenanceLoaded", true); // unblock UI even on error
        }
      }
    },

    async clearSubscriptions({ state }) {
      try {
        // Unsubscribe from all subscriptions
        const unsubscribePromises = state.datastoreSubscriptions.map(
          (subscription) =>
            new Promise((resolve) => {
              try {
                subscription.sub.unsubscribe();
                resolve(); // Assume success unless error is thrown
              } catch (error) {
                console.error("Error unsubscribing:", error);
                resolve(); // Resolve anyway to avoid hanging
              }
            }),
        );

        // Wait for all unsubscriptions to complete
        await Promise.all(unsubscribePromises);

        state.datastoreSubscriptions = [];
        // clearSubscribedTeacherData(state);

        // console.log("All subscriptions cleared");
      } catch (error) {
        console.error("clearSubscriptions action error:", error);
        throw error; // Let the caller handle errors
      }
    },

    async storeSyncedTeacherProductsOrderModels({ commit, state }, payload) {
      if (!state.userSignedIn && !state.isOnline) {
        return;
      }

      // console.log(
      //   "storeSyncedTeacherProductsOrderModels action payload",
      //   payload,
      // );
      commit("storeTeacherProductsOrderModels", payload);
      commit("storePendingTeacherProductsOrder", payload);

      const guestCart = state.guestCart;

      if (
        !state.creatingLocalStorageCartOrder &&
        guestCart &&
        guestCart.orderProducts &&
        guestCart.orderProducts.length > 0
      ) {
        try {
          state.creatingLocalStorageCartOrder = true;

          // Update existing pending order to DRAFT if exists
          if (
            state.syncedPendingTeacherProductsOrder &&
            !state.draftExistingPendingTeacherProductsOrder
          ) {
            state.draftExistingPendingTeacherProductsOrder = true;
            await API.graphql({
              query: mutations.updateTeacherProductsOrder,
              variables: {
                input: {
                  id: state.syncedPendingTeacherProductsOrder.id,
                  _version: state.syncedPendingTeacherProductsOrder._version,
                  orderStatus: "DRAFT",
                },
              },
              authMode: "AMAZON_COGNITO_USER_POOLS",
            });
          }

          // Create new cart order from guest cart
          const newOrderID = () => {
            const now = new Date();
            const year = now.getFullYear().toString().slice(-2); // Get last 2 digits of year
            const month = (now.getMonth() + 1).toString().padStart(2, "0");
            const day = now.getDate().toString().padStart(2, "0");
            const hour = now.getHours().toString().padStart(2, "0");
            const minute = now.getMinutes().toString().padStart(2, "0");
            const second = now.getSeconds().toString().padStart(2, "0");
            const millisecond = Math.floor(now.getMilliseconds() / 10)
              .toString()
              .padStart(2, "0");
            return `${year}${month}${day}-${hour}${minute}${second}${millisecond}`;
          };

          let orderTotal = 0;
          guestCart.orderProducts.forEach((product) => {
            const price = product.price || 0;
            const discount = product.discountPercentage || 0;
            orderTotal += price * (1 - discount / 100);
          });
          const orderVAT = parseFloat(((orderTotal * 0.15) / 1.15).toFixed(2));
          orderTotal = parseFloat(orderTotal.toFixed(2));

          const newOrderInput = {
            teacherprofileID: state.teacherProfileID,
            orderStatus: "PENDING",
            orderProducts: JSON.stringify(guestCart.orderProducts),
            orderID: newOrderID(),
            orderDateTime: new Date().toISOString(),
            orderTotal,
            orderVAT,
            updatedAtMonth: new Date().toISOString().slice(0, 7),
            createdAtMonth: new Date().toISOString().slice(0, 7),
          };

          if (guestCart.coupon) {
            newOrderInput.coupon = JSON.stringify(guestCart.coupon);
          }

          if (guestCart.orderShippingDetails) {
            newOrderInput.orderShippingDetails = JSON.stringify(
              guestCart.orderShippingDetails,
            );
          }

          if (guestCart.meta) {
            newOrderInput.meta = JSON.stringify(guestCart.meta);
          }

          const result = await API.graphql({
            query: mutations.createTeacherProductsOrder,
            variables: { input: newOrderInput },
            authMode: "AMAZON_COGNITO_USER_POOLS",
          });

          // commit(
          //   "storePendingTeacherProductsOrder",
          //   result.data.createTeacherProductsOrder,
          // );

          commit("clearGuestCart");
          state.creatingLocalStorageCartOrder = false;
        } catch (error) {
          console.error("Guest cart sync failed:", error);
        }
      }
    },

    async signOut({ state }) {
      await DataStore.stop().catch(() =>
        // error
        {
          // console.log("error:", error);
        },
      );
      await Auth.signOut().catch(() =>
        // error
        {
          // console.log("error:", error);
        },
      );
      await DataStore.clear().catch(() =>
        // error
        {
          // console.log("error:", error);
        },
      );

      this.commit("storeSubjects", []);
      state.subjectsLoaded = false;

      this.commit("storeSubscriptionAccessProductIds", []);
      this.commit("storeUserSignedIn", false);
      this.commit("storeUserGroups", null);
      this.commit("storeUserEmail", "");
      this.commit("storeTeacherProfileModel", null);
      this.commit("storeSyncedTeacherProfile", false);
      this.commit("storeSyncedTeacherProductsOrders", false);
      this.commit("storeTeacherProductsOrderModels", []);
      this.commit("storeTeacherProfileID", "");
      this.commit("storeTeacherProfileProvince", "");
      this.commit("storeTeacherProfileSchoolID", "");
      this.commit("storeTeacherProfilePayfastSubscriptionToken", "");
      this.commit("storeTeacherProfilePayfastSubscriptionResponse", "");
      this.commit("storeTeacherProfileAppSyncVersion", "");
      this.commit("storeNotReadAnnouncements", null);
      this.commit("storeSubscriptionAccessSynced", false);
      this.commit("storeSubscriptionAccessRecords", []);
      this.commit("storeSubscriptionPackages", []);
      localStorage.removeItem("teacherSessionToken");

      // if (router.currentRoute.path !== '/') {
      //   router.push({ path: '/' })
      // }

      window.location.href = "/";
    },
  },
  modules: {},
});

//Helper functions

function clearSubscribedTeacherData(state) {
  const doesTeacherSubExist = state.datastoreSubscriptions.some((item) =>
    item.model.includes("TeacherProfile"),
  );
  if (!doesTeacherSubExist) {
    // console.log("clearSubscribedTeacherData");
    state.syncedTeacherProfile = false;
    // state.syncedTeacherProfileModel = null;
    // state.teacherProfileID = "";
    // state.teacherProfileProvince = "";
    // state.teacherProfileSchoolID = "";
    // state.teacherProfilePayfastSubscriptionToken = "";
    // state.teacherProfilePayfastSubscriptionResponse = null;
    // state.teacherProfileAppSyncVersion = "";
  }
}
